import React, { useRef, useEffect } from "react";
import "./Header.css"; // Optional: for styling
import back from "../../assets/images/back.png";
import ProfileButton from "./ProfileButton";
import logoSrc from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";

const Header = ({ backDirection, isRecording, showProfileButton = true }) => {
  const navigate = useNavigate();
  const isVideoSubmittedRef = useRef(null);
  useEffect(() => {
    try {
      const videoSubmitted = sessionStorage.getItem("videoSubmitted");
      isVideoSubmittedRef.current = videoSubmitted === "true";
    } catch {}
  }, []);
  const goBack = () => {
    sessionStorage.removeItem("videoSubmitted");
    navigate(backDirection);
  };

  return (
    <header className="app-header">
      <div className="flex">
        {backDirection && !isVideoSubmittedRef.current ? (
          <div className="back-container" onClick={goBack}>
            <img alt="back" src={back} />
          </div>
        ) : (
          <div />
        )}
        <div className="logo-container">
          <img src={logoSrc} alt="Company Logo" className="logo" />
        </div>
      </div>
      {showProfileButton && <ProfileButton isRecording={isRecording} />}
    </header>
  );
};

export default Header;
